import { IEnquiryStep } from './enquiry-form/EnquiryLodgementWizardBreadcrumbs'

export const EnquiryLodgementWizardSteps: IEnquiryStep[] = [
  {
    heading: 'Before you continue your enquiry',
    name: 'Default',
    done: false,
    current: false,
    visible: false,
    step: 0,
  },
  {
    heading: 'Tell us more about your enquiry',
    name: 'Step 1',
    done: false,
    current: false,
    visible: true,
    step: 1,
  },
  {
    heading: 'Tell us more about your enquiry',
    name: 'Step 2',
    done: false,
    current: false,
    visible: true,
    step: 2,
  },
  {
    heading: 'Confirm the details of your enquiry',
    name: 'Confirmation',
    done: false,
    current: false,
    visible: true,
    step: 3,
  },
  {
    heading: 'Thank you',
    name: 'Thank you',
    done: false,
    current: false,
    visible: false,
    step: 4,
  },
]
